<template>
  <div class="pageWrapper">
    <Header></Header>
    <div class="main">
      <router-view :key="key" />
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue"
import Header from "@/components/Header.vue"

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {}
  },

  computed: {
    key() {
      return this.$route.path
    },
  },
}
</script>

<style lang="scss">
body {
  overflow: scroll;
}
.pageWrapper {
  width: 100%;
  overflow: scroll;

  .header {
    width: 100%;
    margin: auto;
    line-height: 60px;
    color: #ffffff;
    height: 60px;
    background-color: #2d6ee8;

    .logo {
      display: inline-block;
      margin: 0 20px 0 0;
      font-size: 20px;
    }

    .pageName {
      display: inline-block;
      font-size: 24px;
    }

    #qLink {
      display: flex;
      justify-content: flex-end;
    }
    #qLink ul {
      flex: 1;
      display: flex;
      justify-content: flex-end;
    }

    #qLink ul li {
      text-align: right;
    }
  }

  .main {
    width: 100%;
    border: 1px solid #ccc;
    margin: 20px auto;
    .el-form {
      margin: 0 20px;
    }
  }
}

@media screen and (min-width: 768px) {
  .pageWrapper {
    .header {
      width: 720px;
    }
    .main {
      width: 720px;
    }
  }
}
@media screen and (min-width: 992px) {
  .pageWrapper {
    .header {
      width: 950px;
    }
    .main {
      width: 950px;
    }
  }
}
@media screen and (min-width: 1200px) {
  .pageWrapper {
    .header {
      width: 1140px;
    }
    .main {
      width: 1140px;
      padding: 30px 20px 50px 20px;
    }
  }
}
</style>
